import React from 'react';

// Renders a 0–5 star rating with a gradient half-star, matching the design.
export default function StarRating({ rating }) {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  const empty = Math.max(0, 5 - full - (half ? 1 : 0));

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 3, margin: '14px 0 16px', fontSize: 18, lineHeight: 1 }}>
      {Array.from({ length: full }).map((_, i) => (
        <span key={`f${i}`} style={{ color: '#F4F3F0' }}>
          ★
        </span>
      ))}
      {half && (
        <span
          style={{
            background: 'linear-gradient(90deg,#F4F3F0 50%,#4a4a52 50%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
          }}>
          ★
        </span>
      )}
      {Array.from({ length: empty }).map((_, i) => (
        <span key={`e${i}`} style={{ color: '#4a4a52' }}>
          ★
        </span>
      ))}
    </div>
  );
}
